import { useState } from "react";
import styles from "../../media.module.css";
import { Members } from "../../data/members";

const DedicatedMembers = () => {
  const [modalImage, setModalImage] = useState()

  return (
    <section className="bg-secondary py-16 px-4 lg:px-14">
      <div className="max-w-7xl mx-auto p-6">
        <div className="text-center mb-20">
          <h1 className="text-primary font-bold text-3xl sm:text-4xl leading-snug uppercase">
            MEET OUR DEDICATED AND TOP MEMBERS
          </h1>
        </div>

        <div className={styles.gallery}>
          {Members.map((member, index) => (
            <div key={index} className={styles.imageBoxx}>
              <div
                className={styles.imageWrapper}
                onClick={() => setModalImage(member.image)}
              >
                <img
                  src={member.image}
                  alt={`headshot ${index + 1}`}
                  className={styles.image}
                />
              </div>
              <div className="bg-red-600 p-3 text-white text-center rounded-b-md">
                <h3 className="font-bold text-sm">{member.name}</h3>
                <p className="text-xs">{member.role}</p>
              </div>
            </div>
          ))}
        </div>

        {modalImage && (
          <div className={styles.modal} onClick={() => setModalImage(null)}>
            <div className={styles.modalContent}>
              <img src={modalImage} alt="Modal" className={styles.modalImage} />
              <div className={styles.close} onClick={() => setModalImage(null)}>
                &times;
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default DedicatedMembers;
